<template>
  <div
    class="
      w-full rounded-2xl border-transparent
      [&_input]:!h-12 [&_input]:!bg-main-very-light-gray [&_input]:placeholder:text-sm
      md:[&_input]:!h-14 md:[&_input]:placeholder:text-base
    "
  >
    <slot />
  </div>
</template>
